import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { queryClient } from 'lib/react-query';
import { AuthProvider } from 'features/login';
import { Navigate } from 'react-router';
import GlobalErrorBoundary from 'components/GlobalErrorBoundary';
import { GridErrorBoundaryFallback } from 'features/cabinet';
import { CabinetRouter, LoginRouter, ServicesRouter } from 'routers';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { defaultShouldDehydrateQuery } from '@tanstack/query-core';

const persister = createAsyncStoragePersister({
  storage: window.localStorage,
});

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {LoginRouter}
      <Route
        path="/"
        element={
          <GlobalErrorBoundary FallbackComponent={GridErrorBoundaryFallback}>
            <AuthProvider />
          </GlobalErrorBoundary>
        }
      >
        {ServicesRouter}
        {CabinetRouter}
        <Route path="*" element={<Navigate to="/services" />} />
        <Route path="" element={<Navigate to="/services" />} />
      </Route>
    </>,
  ),
);

const App = () => (
  <React.StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        dehydrateOptions: {
          shouldDehydrateQuery: (query) =>
            defaultShouldDehydrateQuery(query) &&
            Boolean(query.meta?.persist),
        },
      }}
    >
      <SnackbarProvider
        autoHideDuration={1000}
        maxSnack={1}
        anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        preventDuplicate
      >
        <GlobalErrorBoundary>
          <RouterProvider router={router} />
        </GlobalErrorBoundary>
      </SnackbarProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </PersistQueryClientProvider>
  </React.StrictMode>
);

export default App;
